module.exports = __webpack_public_path__ + "static/media/sanmina.3f9d9631.png";